import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import API from '../endpoints';
import { MatchStatusFilter } from '@repo/types';
import { getAccessToken } from '@data/utils/getAccessToken';

const accessToken = getAccessToken();

// 60 minutes frontend cache for fetching match dates
const CACHE_TIME = 60 * 60 * 1000;

export type MatchDatesQueryParams = {
  startDate?: string;
  endDate?: string;
  status?: MatchStatusFilter;
  competition?: string | null;
  divisions?: string[];
  teamId?: string | null;
};

type QueryOptions = {
  enabled?: boolean;
};

export const useMatchDatesQuery = (params: MatchDatesQueryParams, options?: QueryOptions) => {
  return useQuery({
    queryKey: ['match-dates', params],
    queryFn: fetchMatchDates,
    staleTime: !accessToken ? CACHE_TIME : undefined,
    ...(options ?? {}),
  });
};

const fetchMatchDates: QueryFunction<string[], [string, MatchDatesQueryParams]> = async ({ queryKey }) => {
  const [, params] = queryKey;
  const accessToken = getAccessToken();

  let headers = {};
  if (accessToken) {
    headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const { data } = await axios.get<string[]>(API.endpoints.matchDates, {
    params,
    headers,
  });

  return data;
};
